import TagEmpty from '../../src/legacy/TagEmpty';
export default TagEmpty;
